import { render } from "./AppProfileCard.vue?vue&type=template&id=4b9dfaee"
import script from "./AppProfileCard.vue?vue&type=script&lang=js"
export * from "./AppProfileCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Domain\\repos\\quizup.top\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__